<template>
  <div class="no-info text-center mt-4">
    <div class="row">
      <div class="col-12">
        <em class="no-info__icon" :class="icon" />
      </div>
      <div class="col-12 mt-2">
        <span class="no-info__text">{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Empty",
  props: {
    text: {
      type: String,
      default: "No hay información disponible."
    },
    icon: {
      type: String,
      default: "fal fa-folder-open"
    }
  }
}
</script>

<style lang="scss" scoped>
.no-info {
  &__icon {
    color: #c9c9c9;
    font-size: 50px;
  }

  &__text {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    color: #c9c9c9;
  }
}
</style>
